var responseWindowTimeouts = window.responseWindowTimeouts = [];
var isActiveResponseWindow = window.isActiveResponseWindow = false;
var minimumResponseWindowEnded = true;

//returns an object with this interface:
// (timeout may be missing)
// {
// 	startPosition | starTime:,
// 	timeout:
// }
// startPosition: afterStim|lastStim|withStim
function initResponseWindow(responseWindowValue, waitStimEndValue) {
	console.log('initReponseWindow', responseWindowValue, waitStimEndValue)
	var responseWindow = parseResponseWindow(responseWindowValue);

	//waitStimEnd overwrites responseWindow
	if (waitStimEndValue && waitStimEndValue !== 'na') {
		responseWindow.startPosition = 'afterStim';
		delete responseWindow.startTime;
	}

	return responseWindow;

	function parseResponseWindow(responseWindowValue) {

		var responseWindow = {};

		// default value is lastStim with no timeout
		if (!responseWindowValue || responseWindowValue === 'na') {
			responseWindowValue = 'lastStimAfterStim';
		}
		//we have responseWindow=min:Number;max:Number
		else{
			var parsedMinMaxResponseWindowValue = parseMinMaxResponseWindow(responseWindowValue);
			responseWindowValue = parsedMinMaxResponseWindowValue.responseWindowValue;
			responseWindow.waitTimeout = parsedMinMaxResponseWindowValue.waitTimeout;
		}

		var values = responseWindowValue.split("_");
		var intValue;

		if (values.length > 1) {
			//both position and timeout are set
			//lastStim if empty
			responseWindow.startPosition = values[0] ? values[0] : 'lastStim';

			var timeout = parseInt(values[1]);
			if (timeout && !isNaN(timeout)) {
				responseWindow.timeout = timeout;
			}
		} else {
			//handle values with number values only
			intValue = parseInt(values[0]);
			if (intValue && !isNaN(intValue)) {
				responseWindow.startPosition = 'lastStim';
				responseWindow.timeout = intValue;
			} else {
				//handle values with position only
				responseWindow.startPosition = values[0];
			}
		}

		//if first value is a number, then add it as start time
		var intValue = parseInt(responseWindow.startPosition);
		if (!isNaN(intValue)) {
			delete responseWindow.startPosition;
			responseWindow.startTime = intValue;
		}

		return responseWindow;
	}
}

function parseMinMaxResponseWindow(responseWindowValue){
	var waitTimeout;
	if(responseWindowValue.indexOf('min')>=0){
		//split min from max
		responseWindowValue = responseWindowValue.split(';');

		//consider the case where max is defined before min
		if(responseWindowValue[0].indexOf('min')>=0){
			//get only the Number of min
			waitTimeout = responseWindowValue[0].split(':')[1];
			if(responseWindowValue[1]){
				//get only the Number of max
				responseWindowValue = responseWindowValue[1].split(':')[1];
			}
			else{
				//max is not defined in responseWindow
				responseWindowValue = 'lastStimAfterStim';
			}
		}
		else{
			waitTimeout = responseWindowValue[1].split(':')[1];
			responseWindowValue = responseWindowValue[0].split(':')[1];
		}
	}
	else if(responseWindowValue.indexOf('max')>=0){
		responseWindowValue = responseWindowValue.split(':')[1];
	}

	var result = {}
	result.responseWindowValue = responseWindowValue;
	result.waitTimeout = waitTimeout;
	return result;
}


function enableResponseWindowAtTrialStart(trialRow, onStartedCallback) {

	console.info('RESPONSE WINDOW: enableResponseWindowAtTrialStart', trialRow);

	if (enableResponseWindowAt('allTrial', trialRow, onStartedCallback)) {
		return;
	}

	enableResponseWindowAt('allStim', trialRow, onStartedCallback);
}


function enableResponseWindowWithStim(trialRow, onStartedCallback) {
	enableResponseWindowAt('withStim', trialRow, onStartedCallback);
}

function enableResponseWindowLastStim(trialRow, onStartedCallback) {
	if (enableResponseWindowAt('lastStim', trialRow, onStartedCallback)) {
		return;
	}

	enableResponseWindowAt('lastStimAfterStim', trialRow, onStartedCallback);
}

function enableResponseWindowAfterStim(trialRow, onStartedCallback) {
	console.info('AFTER STIM');
	enableResponseWindowAt('afterStim', trialRow, onStartedCallback);
}

function disableResponseWindowLastStim(trialRow) {

	var responseWindowOptions = window.listTrialResponseWindow[trialRow];

	if (responseWindowOptions.startPosition === 'lastStimAfterStim') {
		return;
	}

	if (responseWindowOptions.timeout > 0) {
		return;
	}

	disableResponseWindowWithStim(trialRow);

	if (responseWindowOptions.startPosition === 'lastStim' || responseWindowOptions.startPosition === 'allStim' ) {
		closeResponseWindowAfterTime(0, 'lastStim');
	}

	//autoadvance if the last screen was closed and the response window was enabled
	if (responseWindowOptions.startPosition === 'withStim' || responseWindowOptions.startPosition === 'lastStim' || responseWindowOptions.startPosition === 'allStim') {
		//default response
		if (!window.hasResponse()) { 
			responseDefaultOnTimeout();
		}
		console.info('autoAdvance lastStim');
		autoAdvance();
	}
}

function disableResponseWindowWithStim(trialRow) {

	var responseWindowOptions = window.listTrialResponseWindow[trialRow];

	console.info('RESPONSE WINDOW: disableResponseWindowWithStim', trialRow, responseWindowOptions.startPosition);

	if (responseWindowOptions.startPosition === 'withStim') {
		closeResponseWindowAfterTime(0, 'withStim');

		showTrialTextAllStim(trialRow, window.minTrialAllImagesTop);
		showTrialTextAllTrial(trialRow, window.minTrialAllImagesTop);//all trial has higher priority over allStim
	}
}



/******************* INTERNAL **********************/

//enables response window if needed at given events
//eventName should be from: allTrial, lastStim, withStim, afterStim
//returns true if window started or scheduled to start
function enableResponseWindowAt(eventName, trialRow, onStartedCallback) {
	if (columnForTrial('type', trialRow) == 'learn') {
		console.info('RESPONSE WINDOW: was not opened as we have a learn trial');
		return false;
	}

	var responseWindowOptions = window.listTrialResponseWindow[trialRow];

	console.info('RESPONSE WINDOW: enableResponseWindowAt', eventName,  trialRow, responseWindowOptions);

	if (responseWindowOptions.startPosition === eventName) {
		openResponseWindowAfterTime(0, trialRow);
		//start the timeout to close the response window if needed
		responseWindowOptions.timeout && closeResponseWindowAfterTime(responseWindowOptions.timeout, eventName);
		return true;
	}

	if (eventName === 'allTrial' && responseWindowOptions.startTime != undefined) {
		console.info('RESPONSE WINDOW: trialStart',  responseWindowOptions.startTime)
		openResponseWindowAfterTime(responseWindowOptions.startTime, trialRow);
		//start the timeout to close the response window if needed
		responseWindowOptions.timeout && closeResponseWindowAfterTime(responseWindowOptions.startTime + responseWindowOptions.timeout, eventName, true);
		return true;
	}

	return false;

	function openResponseWindowAfterTime(delay, trialRow) {
		clearResponseWindowTimeouts();

		console.info('RESPONSE WINDOW:  openResponseWindowAfterTime', delay, trialRow);

		responseWindowSetTimeout(function(){
			window.isActiveResponseWindow = true;
			console.info('RESPONSE WINDOW: enable response window for ', eventName, ' with delay of ', delay);
			enableResponses();
			showTrialTextWithResponseWindow(trialRow);
			onStartedCallback && onStartedCallback();
		}, delay);
	}
}

function closeResponseWindowAfterTime(timeout, eventName, doNotClear) {
	!doNotClear && clearResponseWindowTimeouts();

	if(columnForTrial('responseOptions', window.trialRow)){
		if (columnForTrial('responseOptions', window.trialRow).indexOf('waitTimeout')>=0){
			return;
		}
	}

	if (timeout) {
		responseWindowSetTimeout(close, timeout);
	} else {
		close();
	}


	function close() {

		if (timeout > 0) {
			//default response
			if (!window.hasResponse()) { 
				responseDefaultOnTimeout();
			}
		}

		window.isActiveResponseWindow = false;
		window.recordKeys = 0;
		hideResponses();
		clearSliders();
		resetResponseWindow();
		clearResponseWindowTimeouts();
		//hide reponse window text
		console.info('RESPONSE WINDOW: timeout response window for', eventName, ' after ', timeout);
		//responseWindow was timeout based
		if (timeout > 0) {
			console.info('autoAdvance');
			//autoadvance to the next Trial
			autoAdvance();
		}
	}
}


function responseWindowSetTimeout(callback, timeout) {
	console.info('RESPONSE WINDOW responseWindowSetTimeout', callback, timeout);
	
	if (timeout > 0) {
		//using setTimeout here to more accurately stop responses instead of increments of frames(usually 16ms)
		var to = window.postpone(callback, timeout, window.lastTs);
		window.responseWindowTimeouts.push(to);
	}
	else{
		callback();
	}
}

function clearResponseWindowTimeouts() {
	console.info('RESPONSE WINDOW clearResponseWindowTimeouts');
	var to;

	if (window.responseWindowTimeouts) {
		while (to = window.responseWindowTimeouts.shift()) {
			window.clearPostpone(to);
		}
	}
}


function resetResponseWindow() {
	//disable keys input
	window.recordKeys = 0;
	//disable clicks
	for (var i = 1; i <= window.stimFieldsMax; i++) {
		if(stimContainers[i].id.indexOf('video') < 0){
			window.stimContainers[i].className = 'nonclickableImage';
		}
	}

	//hide input box and buttons
	for (var i = 0; i < window.buttonsContainers.length; i++) {
		window.buttonsContainers[i].style.display = 'none';
	}

	//used for input
	window.recordRTkeys = 0;
}

function disableClickOnImages() {
	//disable clicks
	for (var i = 1; i <= window.stimFieldsMax; i++) {
		window.stimContainers[i].className = 'nonclickableImage';
	}
}

function shouldWaitResponseWindow() {
	options = listTrialResponseOptions[window.trialRow];
	if(options && options.waitForResponseWindow === true){
		return true;
	}
	return false;
}

function hasMinimumResponseWindow() {
	if(window.listTrialResponseWindow[window.trialRow].waitTimeout) {
		return true;
	}

	return false;
}

function waitingForMinimumResponseWindow() {
	if(hasMinimumResponseWindow() && !window.minimumResponseWindowEnded){
		return true;
	}
	return false;
}

//responseOptions min:duration function
function enableResponseWindowAfterMinimumDuration(disableCallback, enableCallback) {
	const waitDuration = window.listTrialResponseWindow[window.trialRow].waitTimeout;
	if(!waitDuration) {
		return;
	}

	disableCallback();
	
	setTimeout(enableCallback, waitDuration);
}